import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	customerId: z.string().optional(),
	extractionIds: z.string().optional(),
});

export const Route = createFileRoute("/_app/invoices/generate")({
	validateSearch: searchSchema,
});
